<app-home-page-card>
  <app-home-page-card-header [title]="'HOME_PAGE.BUSINESS_ACCOUNTS.TITLE'" imageUrl="images/home-accounts.svg">
    <div>
      <div *ngIf="accountGroups$ | async; else noAccounts">
        <span class="account-number" *ngIf="totalResults$ | async as results; else noAccounts">
          <a [routerLink]="manageAccountsPage" [attr.data-action]="'business-manage-accounts'">
            {{ results }}
          </a>
          &nbsp;
          <span [ngPlural]="results">
            <ng-template ngPluralCase="=1">
              <span class="account-desc">
                {{ 'HOME_PAGE.BUSINESS_ACCOUNTS.ACCOUNTS_ADDED_SINGULAR' | translate }}
              </span>
            </ng-template>
            <ng-template ngPluralCase="other">
              <span class="account-desc">
                {{ 'HOME_PAGE.BUSINESS_ACCOUNTS.ACCOUNTS_ADDED_PLURAL' | translate }}
              </span>
            </ng-template>
          </span>
        </span>
      </div>
      <ng-template #noAccounts>
        <span class="account-number">0&nbsp;</span>
        <span class="account-desc">
          {{ 'HOME_PAGE.BUSINESS_ACCOUNTS.ACCOUNTS_ADDED_PLURAL' | translate }}
        </span>
      </ng-template>
    </div>
  </app-home-page-card-header>
  <app-home-page-card-footer
    cardContext="business-accounts"
    [courseParams]="courseParams"
    [ctaButtons]="[
      {
        text: 'HOME_PAGE.BUSINESS_ACCOUNTS.CREATE_ACCOUNT',
        url: businessSearchPage,
      },
    ]"
  >
    <div class="row col-xs-12 home-page-card-learn-more-content-info">
      <p>
        {{ 'HOME_PAGE.BUSINESS_ACCOUNTS.ACCOUNTS_INFO_FIRST_PARAGRAPH' | translate }}
      </p>
      <br />
      <p>
        {{ 'HOME_PAGE.BUSINESS_ACCOUNTS.ACCOUNTS_INFO_SECOND_PARAGRAPH' | translate }}
      </p>
      <br />
      <div>
        <mat-icon class="check-icon">done</mat-icon>
        <div class="content-point">
          {{ 'HOME_PAGE.BUSINESS_ACCOUNTS.ACCOUNTS_INFO_POINT_1' | translate }}
        </div>
      </div>
      <div>
        <mat-icon class="check-icon">done</mat-icon>
        <div class="content-point">
          {{ 'HOME_PAGE.BUSINESS_ACCOUNTS.ACCOUNTS_INFO_POINT_2' | translate }}
        </div>
      </div>
      <div>
        <mat-icon class="check-icon">done</mat-icon>
        <div class="content-point">
          {{ 'HOME_PAGE.BUSINESS_ACCOUNTS.ACCOUNTS_INFO_POINT_3' | translate }}
        </div>
      </div>
      <div>
        <mat-icon class="check-icon">done</mat-icon>
        <div class="content-point">
          {{ 'HOME_PAGE.BUSINESS_ACCOUNTS.ACCOUNTS_INFO_POINT_4' | translate }}
        </div>
      </div>
      <div style="clear: both"></div>
      <br />
      <br />
    </div>
  </app-home-page-card-footer>
</app-home-page-card>
